import CryptoJS from 'crypto-js';

const getEncryptionKey = () => {
  let key = localStorage.getItem('app_key');
  if (!key) {
    key = CryptoJS.lib.WordArray.random(256/8).toString();
    localStorage.setItem('app_key', key);
  }
  return key;
};

export const secureStorage = {
  setItem: (key, value) => {
    try {
      // ✅ Convert any value to a safe string format
      let stringValue;
      
      if (value === null || value === undefined) {
        stringValue = '';
      } else if (typeof value === 'object') {
        stringValue = JSON.stringify(value);
      } else {
        stringValue = String(value);
      }
      
      const encryptionKey = getEncryptionKey();
      const encrypted = CryptoJS.AES.encrypt(stringValue, encryptionKey).toString();
      localStorage.setItem(`sec_${key}`, encrypted);
    } catch (error) {
      console.error(`Failed to encrypt and store ${key}:`, error, 'Value:', value);
      // Still try to store as encrypted empty string as fallback
      const encryptionKey = getEncryptionKey();
      const encrypted = CryptoJS.AES.encrypt('', encryptionKey).toString();
      localStorage.setItem(`sec_${key}`, encrypted);
    }
  },
  
  getItem: (key) => {
    const encryptionKey = getEncryptionKey();
    const encrypted = localStorage.getItem(`sec_${key}`);
    if (!encrypted) return null;
    
    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, encryptionKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      
      // ✅ Try to parse as JSON if it looks like JSON, otherwise return as string
      if (decrypted.startsWith('{') || decrypted.startsWith('[')) {
        try {
          return JSON.parse(decrypted);
        } catch {
          return decrypted;
        }
      }
      
      return decrypted;
    } catch {
      return null;
    }
  },
  
  removeItem: (key) => {
    localStorage.removeItem(`sec_${key}`);
  },

  clear: () => {
    // Get all localStorage keys
    const keys = Object.keys(localStorage);
    
    // Remove only keys that start with 'sec_' (your encrypted data)
    keys.forEach(key => {
      if (key.startsWith('sec_')) {
        localStorage.removeItem(key);
      }
    });
    
    // Also clear the encryption key
    localStorage.removeItem('app_key');
  }
};

